import { render } from "./PlatformDropdown.vue?vue&type=template&id=402e18f8&ts=true"
import script from "./PlatformDropdown.vue?vue&type=script&lang=ts"
export * from "./PlatformDropdown.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSeparator});
